<button
  class="single-sign-on__identity-provider"
  data-track
  ftrButton
  [fullWidth]="true"
  color="secondary"
  (click)="startSSOLogin(identityProvider.Google)"
>
  <ftr-icon-legacy icon="Google" align="Top" />
  Continue with Google
</button>
<button
  class="single-sign-on__identity-provider"
  data-track
  ftrButton
  [fullWidth]="true"
  color="secondary"
  (click)="startSSOLogin(identityProvider.Microsoft)"
>
  <ftr-icon-legacy icon="Microsoft" align="Top" />
  Continue with Microsoft
</button>
@if (showMockLogin) {
  <button
    class="single-sign-on__identity-provider"
    data-track
    ftrButton
    [fullWidth]="true"
    color="secondary"
    id="mockLoginButton"
    (click)="startSSOLogin(identityProvider.Mock)"
  >
    Continue with Mock
  </button>
}
